import {
  getActionColor,
  getColorScales,
  getContrastTextColors,
  getBackground,
  getLauncherButtonColor,
} from "@/lib/client/utils/theme/theme";
import type { Theme } from "@/lib/client/utils/theme/types";
import type { MessengerConfig } from "@deskpro-product/messenger-api-schemas/messenger/config";

export default function launcherInit(
  config: MessengerConfig,
  setConfig: (config: MessengerConfig) => void,
  setTheme: (theme: Theme) => void,
) {
  setConfig(config);

  const actionColor = getActionColor(config);
  const launcherButtonColor = getLauncherButtonColor(config);

  const { light: actionLightScale, dark: actionDarkScale } = getColorScales(actionColor);
  const { light: launcherButtonLightScale } = getColorScales(launcherButtonColor);
  const contrastTextColors = getContrastTextColors(actionColor);
  const background = getBackground(config);
  const theme: Theme = {
    light: {
      actionColor,
      actionColorScale: actionLightScale,
      launcherButtonColor,
      contrastTextColor: contrastTextColors.light,
      background,
    },
    dark: {
      actionColor: actionLightScale[700],
      actionColorScale: actionDarkScale,
      launcherButtonColor: launcherButtonLightScale[700],
      contrastTextColor: contrastTextColors.dark,
      background,
    },
  };
  setTheme(theme);
}
